export default __webpack_public_path__ + "static/media/metamask.3e4a38bb.png";